/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSnackbar } from 'notistack';
import { dispatch, useSelector } from 'src/redux/store';
import { createPaymentAsaas } from 'src/redux/slices/checkout/checkout';
import useAuth from 'src/hooks/useAuth';
import { SEND_EMAIL_TO } from 'src/config';
import { post } from 'src/redux/slices/api/api';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { getDiscount, getStudiesAndVersions, getStudyById } from "src/redux/slices/dashboard/studies";
import useViabilityCalculator from 'src/hooks/useViabilityCalculator';
import ReactPixel from 'react-facebook-pixel';
import { updateSelectedOptions } from 'src/redux/slices/viabilityStudy/viabilityStudy';
import { calcValuesByHa } from 'src/utils/utils';
import { setSelectedOptions } from 'src/redux/slices/viabilityCalculator/viabilityCalculator';

export default function useCheckout(){
  const { study, isLoading, allStudies } = useSelector((state) => state.studies);
  const { selectedOptions } = useSelector((state) => state.calculator);
  const { updateHa } = useViabilityCalculator();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { studyId } = useParams();
  const { user } = useAuth();
  const paymentOptions = ["CRÉDITO", "Gerar cobrança"];

  const [isLoadingButton, setLoadingButton] = useState(false);
  const [errorCupom, setErrorCupom] = useState(false);
  const [ha, setHa] = useState(0);
  const [cupom, setCupom] = useState("");
  const [discount, setDiscount] = useState(null);
  const [personal, setPersonal] = useState(null);
  const [address, setAddress] = useState(null);
  const [cumpomMensagem, setCumpomMensagem] = useState("");
  const [paymentMethod, setPaymentMethod] = useState(1);
  const [totalValue, setTotalValue] = useState(0);
  const [viabilityValue, setViabilityValue] = useState(0);
  const [conceptValue, setConceptValue] = useState(0);
  const [dwgValue, setDwgValue] = useState(0);
  const [directorPlanValue, setDirectorPlanValue] = useState(0);
  const [downloadStudyValue, setDownloadStudyValue] = useState(0);
  const [hasDirectorPlan, setHasDirectorPlan] = useState(false);
  const [hasConcept, setHasConcept] = useState(false);
  const [evuComplete, setEvuComplete] = useState(false);
  const [dwgStudy, setDwgStudy] = useState(false);
  const [downloadStudy, setDownloadStudy] = useState(false);
  const [alreadySetInitialValues, setAlreadySetInitialValues] = useState(false);
  const [optionsValue, setOptionsValue] = useState({
    completeEvu: 0,
    directorPlan: 0,
    concept: 0,
    dwgStudy: 0,
    downloadStudy: 0
  });
  const [isNewCalc, setIsNewCalc] = useState(false);
  const [selectedService, setSelectedService] = useState<string | null>(null);

  const getStudy = async () => {
    const db = firebase.firestore();
    const study = await db.collection("studies").doc(user!.uid).collection('data').doc(studyId).get();
    const data = study.data();
    const floatValue = parseFloat(data?.area ? data?.area?.replace(/[^\d.]/g, '') : '0');
    setHa(floatValue);
    setOptionsValue({
      completeEvu: data?.optionsValue?.completeEvu || calcValuesByHa(floatValue, "completeEvu"),
      directorPlan: data?.optionsValue?.directorPlan || calcValuesByHa(floatValue, "directorPlan"),
      concept: data?.optionsValue?.concept || calcValuesByHa(floatValue, "concept"),
      dwgStudy: data?.optionsValue?.dwgStudy || calcValuesByHa(floatValue, "dwgStudy"),
      downloadStudy: data?.optionsValue?.downloadStudy || calcValuesByHa(floatValue, "downloadStudy")
    });
    dispatch(setSelectedOptions({
      completeEvu: data?.selectedOptions?.completeEvu,
      directorPlan: data?.selectedOptions?.directorPlan,
      concept: data?.selectedOptions?.concept,
      dwgStudy: data?.selectedOptions?.dwgStudy,
      downloadStudy: !!data?.selectedOptions?.downloadStudy
    }));
    if(data?.optionsValue) {
      setIsNewCalc(true);
    } else {
      setIsNewCalc(false);
    }
  }

  useEffect(() => {
    setHasDirectorPlan(selectedOptions.directorPlan);
    setHasConcept(selectedOptions.concept);
    setEvuComplete(selectedOptions.completeEvu);
    setDwgStudy(selectedOptions.dwgStudy);
    setDownloadStudy(selectedOptions.downloadStudy);
    if(selectedOptions.completeEvu) {
      setSelectedService('completeEvu');
    } else if (selectedOptions.directorPlan) {
      setSelectedService('directorPlan');
    } else if (selectedOptions.downloadStudy) {
      setSelectedService('downloadStudy');
    } else {
      setSelectedService(null);
    }
    setAlreadySetInitialValues(true);
  }, [selectedOptions])

  useEffect(() => {
    if (studyId) {
      dispatch(getStudiesAndVersions(user?.uid))
    }
    getStudy();
  }, [user!.uid, studyId])

  useEffect(() => {
    var newValue = 0;
    let directorPlanValue = optionsValue.directorPlan;
    let conceptValue = optionsValue.concept;
    let evuValue = optionsValue.completeEvu;
    let dwgValue = optionsValue.dwgStudy;
    let downloadStudyValue = optionsValue.downloadStudy;
    if (hasDirectorPlan) newValue += directorPlanValue
    if (hasConcept) newValue += conceptValue;
    if (evuComplete) newValue += evuValue;
    if (dwgStudy) newValue += dwgValue;
    if (downloadStudy) newValue += downloadStudyValue;
    setConceptValue(conceptValue);
    setViabilityValue(evuValue);
    setDwgValue(dwgValue);
    setDirectorPlanValue(directorPlanValue);
    setDownloadStudyValue(downloadStudyValue);
    setTotalValue(newValue)
    if(alreadySetInitialValues && studyId && user) {
      const newOptions = {
        directorPlan: hasDirectorPlan,
        concept: hasConcept,
        dwgStudy: dwgStudy,
        completeEvu: evuComplete,
        downloadStudy: downloadStudy
      };
      dispatch(updateSelectedOptions(user, studyId, newOptions))
    }
  }, [hasDirectorPlan, hasConcept, ha, dwgStudy, evuComplete])

  useEffect(() => {
    allStudies.forEach((item) => {
      if ('paymentStatus' in item && (study?.hasDiscount !== 0.2 || study?.hasDiscount === undefined) ) {
        setDiscount(0);
      }
    });
  }, [allStudies]);

  useEffect(() => {
    if (studyId) {
      dispatch(getStudyById(user?.uid, studyId))
    }
  }, [user?.uid, studyId])

  useEffect(() => {
    if (study?.area != null) {
      updateHa(study?.area)
    }
  }, [study]);

  useEffect(() => {
    ReactPixel.pageView();
  }, [])

  const backToDashboard = () => {
    navigate('/dashboard')
  }

  const handlePersonal = (info: any) => {
    setPersonal(info);
  }

  const handleAddress = (info: any) => {
    setAddress(info);
  }

  const handlePayment = async (info: any) => {
    let errorMessage = '';
    try {
      setLoadingButton(true);
      const db = firebase.firestore();
      let aditionalInfo = {};
      let message = '';

      if (paymentMethod === 0) {
        message = 'Pagamento realizado!';
        errorMessage = 'Erro no pagamento, revise os dados do seu cartão.';
        aditionalInfo = {
          method: "CREDIT_CARD",
          cardInfo: {
            name: info.name,
            number: info.credit.replace(/\s/g, ''),
            expiryMonth: info.validade.split('/')[0],
            expiryYear: '20' + info.validade.split('/')[1],
            cvv: info.codigo
          }
        }
      } else {
        message = 'Boleto gerado!';
        errorMessage = 'Erro ao gerar o boleto.';
        aditionalInfo = {
          method: "BOLETO",
        }
      }

      let newValue = 0;
      if (discount) {
        newValue = (1 - discount) * totalValue
      } else {
        newValue = totalValue
      }

      const payload = {
        cpf: info.cpf.replace(/[^\d]/g, ""),
        studyId: studyId,
        userUid: user!.uid,
        name: user!.name,
        corporate: user!.corporate,
        cnpj: user!.cnpj.replace(/[^\d]/g, ""),
        email: user!.email,
        postalCode: info.cep.replace(/\D/g, ''),
        phone: "51998825571",
        addressNumber: info.number,
        totalValue: newValue,
        customerPhone: info.phone.replace(/\D/g, ''),
        selectedOptions: selectedOptions,
        ...aditionalInfo
      }
      const assasResponse = await dispatch(createPaymentAsaas(payload));

      const selectedServices = [];
      if (evuComplete) selectedServices.push('Estudo de viabilidade');
      if (hasConcept) selectedServices.push('Concept');
      if (hasDirectorPlan) selectedServices.push('Análise do plano diretor');
      if (dwgStudy) selectedServices.push('Estudo em DWG');
      if (downloadStudy) selectedServices.push('Download do (.dxf)');

      var study = await db.collection("studies").doc(user!.uid).collection('data').doc(studyId).get();
      var studyData = study.data();
      studyData!.selectedOptions.directorPlan = hasDirectorPlan;
      studyData!.selectedOptions.concept = hasConcept;
      studyData!.selectedOptions.dwgStudy = dwgStudy;
      studyData!.selectedOptions.completeEvu = evuComplete;
      studyData = { ...studyData, paymentId: assasResponse.id, hasDiscount: discount , totalValue: newValue, paymentStatus: assasResponse.status, selectedServices: selectedServices };
      await db.collection("studies").doc(user!.uid).collection('data').doc(studyId).set(studyData);

      sendPaymentEmail(user);

      if (assasResponse && paymentMethod === 1) {
        window.open(assasResponse?.bankSlipUrl, "_blank");
      }
      enqueueSnackbar(message);
      navigate('/dashboard');
    } catch (error) {
      enqueueSnackbar(errorMessage, { variant: 'error' });
      console.error(error);
    } finally {
      setLoadingButton(false);
    }
  }

  const sendPaymentEmail = async (user: any) => {
    const db = firebase.firestore();
    for (const email of SEND_EMAIL_TO) {
      const helper = {
        to: email,
        subject: "Usuário realizou pagamento!",
        body: `O usuário ${user?.name} com email ${user?.email} gerou um pagamento de um estudo na Plataforma!`
      };
      await post('/mail/send', helper);
      await db.collection("logs").add(helper);
    }
  }

  const aplicarCupom = async () => {
    const res = await getDiscount(cupom);
    if (res && res.discount) {
      const cupomDiscount = res.discount / 100;
      if (!discount || cupomDiscount > discount) {
        setDiscount(cupomDiscount)
        setCumpomMensagem(`Desconto de ${res.discount}% aplicado`)
      } else {
        setCumpomMensagem("Desconto maior já aplicado")
      }
      setErrorCupom(false)
    } else {
      setCumpomMensagem("Cupom inválido ou inexistente")
      setErrorCupom(true)
    }
  }

  const handleServiceChange = (service: string) => {
		if(selectedService === service) return setSelectedService(null);
		setSelectedService(service);
	}

	useEffect(() => {
    if(isNewCalc && alreadySetInitialValues) {
      if (selectedService === 'completeEvu') {
        setEvuComplete(true);
        setHasDirectorPlan(false);
        setDownloadStudy(false);
      } else if (selectedService === 'directorPlan') {
        setHasDirectorPlan(true);
        setEvuComplete(false);
        setHasConcept(false);
        setDwgStudy(false);
        setDownloadStudy(false);
      } else if (selectedService === 'downloadStudy') {
        setDownloadStudy(true);
        setHasDirectorPlan(false);
        setEvuComplete(false);
        setHasConcept(false);
        setDwgStudy(false);
      } else {
        setEvuComplete(false);
        setHasDirectorPlan(false);
        setHasConcept(false);
        setDwgStudy(false);
        setDownloadStudy(false);
      }
    }
	}, [selectedService, setEvuComplete, setHasConcept, setHasDirectorPlan, setDwgStudy])

  return {
    isLoading,
    isLoadingButton,
    study,
    viabilityValue,
    conceptValue,
    directorPlanValue,
    dwgValue,
    downloadStudyValue,
    totalValue,
    hasDirectorPlan,
    hasConcept,
    evuComplete,
    dwgStudy,
    downloadStudy,
    paymentMethod,
    paymentOptions,
    personal,
    address,
    discount,
    cupom,
    errorCupom,
    cumpomMensagem,
    isNewCalc,
    setDwgValue,
    setDirectorPlanValue,
    setTotalValue,
    setDownloadStudyValue,
    setEvuComplete,
    setHasDirectorPlan,
    setHasConcept,
    setDwgStudy,
    setDownloadStudy,
    handlePayment,
    handlePersonal,
    handleAddress,
    setPaymentMethod,
    setCupom,
    aplicarCupom,
    backToDashboard,
    handleServiceChange
  };
}
